import { Moment } from 'moment';
import { Address2ComponentValue } from './address2-component.domain';
import { AggregatorSearchComponentValue } from './aggregator-search-component.domain';
import { AssetConditionValue } from './asset-condition-component.domain';
import { AssetSelectionComponentValue } from './asset-selection-component.domain';
import { BalloonPaymentValue } from './balloon-payment-component.domain';
import { BrokerageSelectionValue } from './brokerage-selection-component.domain';
import { BusinessSearchValue } from './business-search-component.domain';
import { EntityTypeValue } from './entity-type-component.domain';
import { FinanceTypeValue } from './finance-type-component.domain';
import { PaymentFrequencyValue } from './payment-frequency-selection-component.domain';
import { PrimaryIndustrySelectionValue } from './primary-industry-selection-component.domain';
import { SecondaryIndustrySelectionValue } from './secondary-industry-selection-component.domain';
import { YesNoValue } from './yes-no-component.domain';

import { ApplicationApplicant } from '../../domain/types.domain';
import { AssetFinanceProductType } from '../application-service.domain';
import { TransactionValue } from '../component/transaction-type-component.domain';
import { GuarantorValue } from './guarantor-component.domain';
import { LoanPurposeValue } from './loan-purpose-selection-component.domain';
import { LoanTermsSelectionWithInputValue } from "./loan-terms-selection-with-input-component.domain";
import { ReferenceValue } from './reference-component.domain';
import { SalesforceContactSameAccountSelectionValue } from './salesforce-contact-same-account-selection-component.domain';
import { ContactValue, SummaryContactValue } from './select-contact-component.domain';
import { UserSelectionValue } from './user-selection-component.domain';
import { SubdivisionIndustrySelectionValue } from './subdivision-industry-selection-component.domain';

export type ApplicationSelectionType = 'app' | 'quote' | 'bank-statement' | 'asset' | 'credit' | 'documents' | 'kyc-aml' | 'add-asset' | 'lvr-calculator' | 'pricing' |'credit-report';

export interface ApplicationSelectionObject {
  selection: ApplicationSelectionType;
  innerTabParam: string | undefined;
}
export interface AssetFinanceSummary {
  repayment: string;
  estimatedDrawDownDate: Moment;
  brokerApplicationId: string;
  organisation: BusinessSearchValue;
  addtionalBrokerCorrespondent: UserSelectionValue;
  broker: AggregatorSearchComponentValue;
  productType: AssetFinanceProductType;
  isSwitchToEasyDoc: boolean;
  invoiceAmount: number;
  depositAmount: number;
  loanAmount: number;
  loanPurpose: LoanPurposeValue;
  asset: AssetSelectionComponentValue;
  assetCondition: AssetConditionValue,
  transactionType: TransactionValue,
  loanTerms: LoanTermsSelectionWithInputValue,
  paymentFrequency: PaymentFrequencyValue,
  financeType: FinanceTypeValue;
  docFee: YesNoValue,
  balloonPayment: BalloonPaymentValue,
  balloonPaymentValue: number,
  brokerOriginationFee: number;
  brokerage: BrokerageSelectionValue,
  propertyOwner: YesNoValue,
  adverseOnFile: YesNoValue,
  equifaxScoreAboveThreshold: YesNoValue,
  equifaxDirectorScoreAbove700: YesNoValue,
  organisationType: EntityTypeValue,
  abn: string;
  acn?: string;
  annualRevenue: number;
  primaryIndustry: PrimaryIndustrySelectionValue,
  industrySector: SecondaryIndustrySelectionValue,
  subdivisionIndustrySector: SubdivisionIndustrySelectionValue,
  address: Address2ComponentValue,
  // Broker flows only; the direct-sale pages never collect it.
  registeredBusinessAddress?: Address2ComponentValue,
  applicants: Exclude<ApplicationApplicant, null>,
  guarantors: GuarantorValue;
  primaryContact: ContactValue;
  contacts?: SummaryContactValue[];
  brokerFlowId?: string;
  references: ReferenceValue;
  applicationNotes: string;
  brokerContact:SalesforceContactSameAccountSelectionValue;
}
